import { Routes } from '@angular/router';
import { ValidateComponent } from './routes/validate/validate.component';
import { loginGuard } from '@guards/login.guard';
import { OrgGuard } from '@guards/org.guard';
import { VenuesComponent } from './routes/main/venues/venues.component';
import { MainComponent } from './routes/main/main.component';
import { HomeComponent } from './routes/main/home/home.component';
import { OrganisationCustomerListComponent } from './routes/main/organisation-customers-list/organisation-customers-list.component';
import { OrganisationCustomerComponent } from './routes/main/organisation-customers-list/organisation-customer/organisation-customer.component';
import { VenueCustomerComponent } from './routes/main/organisation-customers-list/venue-customer/venue-customer.component';
import { DispatchListComponent } from './routes/main/crm/dispatch-list/dispatch-list.component';
import { DispatcAdministrationComponent } from './routes/main/crm/dispatc-administration/dispatc-administration.component';
import { TriggersComponent } from './routes/main/crm/triggers/triggers.component';
import { UserEditorComponent } from './routes/main/admin/user-administration/user-editor/user-editor.component';
import { UserAdministrationComponent } from './routes/main/admin/user-administration/user-administration.component';
import { FunPayHomeComponent } from './routes/main/funpay/funpay';
import { FunPayDashboardComponent } from './routes/main/funpay/funpay-dashboard/funpay-dashboard';
import { FunPayOnboardingComponent } from './routes/main/funpay/funpay-onboarding/funpay-onboarding';
import { scopeGuard } from '@guards/scope.guard';
import { featureScopes } from '../../../../../common/common-types/user-scopes';

const requires = (scope: (typeof featureScopes)[keyof typeof featureScopes]) => ({ canActivate: [scopeGuard], data: { scope } });

export const routes: Routes = [
    { path: '', component: ValidateComponent },
    {
        path: 'organizations/:id',
        component: MainComponent,
        canActivate: [loginGuard, OrgGuard],
        canActivateChild: [OrgGuard],
        children: [
            { path: '', component: HomeComponent },
            { path: 'venues', component: VenuesComponent },
            { path: 'crm/customers', component: OrganisationCustomerListComponent, ...requires(featureScopes.customers) },
            { path: 'crm/customers/:cid', component: OrganisationCustomerComponent, ...requires(featureScopes.customers) },
            { path: 'crm/customers/:cid/venues/:clientId', component: VenueCustomerComponent, ...requires(featureScopes.customers) },
            { path: 'crm/campaigns', component: DispatchListComponent, ...requires(featureScopes.campaigns) },
            { path: 'crm/campaigns/:campaignId', component: DispatcAdministrationComponent, ...requires(featureScopes.campaigns) },
            { path: 'crm/triggers', component: TriggersComponent, ...requires(featureScopes.triggers) },

            // Settings was an empty placeholder; keep old links working.
            { path: 'admin/settings', redirectTo: 'admin/users' },
            { path: 'admin/users', component: UserAdministrationComponent, ...requires(featureScopes.users) },
            { path: 'admin/users/new', component: UserEditorComponent, ...requires(featureScopes.users) },
            { path: 'admin/users/:userId', component: UserEditorComponent, ...requires(featureScopes.users) },
            { path: 'funpay', component: FunPayHomeComponent, ...requires(featureScopes.funpay) },
            { path: 'funpay/:id', component: FunPayDashboardComponent, ...requires(featureScopes.funpay) },
            { path: 'funpay/:id/onboarding', component: FunPayOnboardingComponent, ...requires(featureScopes.funpay) }
        ]
    },
    { path: '**', redirectTo: '' }
];
